import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { SliderComponent } from '@shared/components/slider/slider.component'
import { SlideItemDirective } from '@shared/directives/slider-item.directive'
import { KpisSummaryCardComponent } from '@shared/components/kpis-summary-card/kpis-summary-card.component'
import { UserWithSummary } from '@core/interfaces/kpis.interface'

@Component({
  selector: 'kpis-summary-list',
  imports: [SliderComponent, SlideItemDirective, KpisSummaryCardComponent],
  templateUrl: './kpis-summary-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpisSummaryListComponent {
  users = input.required<UserWithSummary[]>()
}
